// Debe coincidir con validateNewPassword del back (PasswordChangeService).
// La usan el cambio de contraseña obligatorio, la activación de cuentas invitadas
// y la recuperación de contraseña.
export const PASSWORD_RULES = [
  { label: "Al menos 10 caracteres", test: (p) => p.length >= 10 },
  { label: "Una letra mayúscula", test: (p) => /[A-Z]/.test(p) },
  { label: "Una letra minúscula", test: (p) => /[a-z]/.test(p) },
  { label: "Un número", test: (p) => /[0-9]/.test(p) },
];
